
import { defineComponent, h, PropType } from 'vue';
import { BlockContent } from '@/sanity/blocks';
import { getImageAttributes } from '@/sanity';
import { SanityImageObject } from '@sanity/image-url/lib/types/types';
import ImageWrap from '@/components/ImageWrap.vue';

export default defineComponent({
  props: {
    _key: {
      type: String,
      default: '',
    },
    _type: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'left',
    },
    text: {
      type: Array as PropType<Array<any>>,
      default: () => [],
    },
  },
  setup(props) {
    return () => {
      const column = (child: any, classes = '') =>
        h('div', { class: ['w-full lg:w-1/2 px-2 my-8', classes] }, child);

      const allBlocks = props.text;
      const imageBlock = props.text.find((block) => block._type === 'image');

      const text = (align: string) =>
        column(
          h(BlockContent, {
            blocks: allBlocks,
            class: ['text-content max-w-xl', align],
            renderContainerOnSingleChild: true,
            serializers: {
              types: {
                image: (block: { node: SanityImageObject }) => {
                  const image = getImageAttributes(
                    { asset: block.node.asset },
                    1000
                  );
                  return h(
                    'div',
                    { class: 'lg:hidden image-block max-w-xs mx-auto' },
                    h('img', { src: image.src })
                  );
                },
              },
            },
          })
        );

      const image = (margins: string) =>
        column(
          imageBlock
            ? h(ImageWrap, {
                class: ['story-split-image', margins],
                image: getImageAttributes(imageBlock, 2000),
              })
            : '',
          'hidden lg:flex items-center'
        );

      const columns =
        props.layout === 'left'
          ? [text('ml-auto mr-auto lg:mr-0 lg:ml-auto'), image('mt-12 lg:mt-0')]
          : [
              image('mb-12 lg:mb-0'),
              text('ml-auto mr-auto lg:ml-0 lg:mr-auto'),
            ];

      return h(
        'div',
        { class: 'story-section px-8 lg:px-4' },
        h('div', { class: 'flex flex-wrap -mx-2 -my-8' }, columns)
      );
    };
  },
});
